import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  productTitle: Yup.string()
    .trim(),
  productDescription: Yup.string()
    .trim(),
  templateId: Yup.string()
    .trim()
    .required('Template ID is required'),
  ctaButtonTitle: Yup.string()
    .trim(),
  customScheduleHeader: Yup.string()
    .trim()
    .required('Custom Schedule Header is required!'),
  firstTermsOfServiceDescription: Yup.string().when('showFirstTermsOfService', {
    is: (val: any) => Boolean(val),
    then: () => Yup.string().trim().required('Terms description is required when enabled'),
  }),
  secondTermsOfServiceDescription: Yup.string().when('showSecondTermsOfService', {
    is: (val: any) => Boolean(val),
    then: () => Yup.string().trim().required('Terms description is required when enabled'),
  }),
});

export default validationSchema;
